import { ICompanySocialMedia } from "@/api/AppApi/services/company/interfaces/ICompany";
import ContactUsSubtitle from "./ContactUsSubtitle";
import NextImage from "../../lib/NextImage";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  social_media: ICompanySocialMedia[];
}
const ContactUsSocial: React.FC<Props> = ({ social_media }) => {
  const t = useTranslation();
  return (
    <div>
      <ContactUsSubtitle text={t.social_networks} />
      <div className="contact-us-social">
        {social_media?.map((s, key) => (
          <a key={key} target="_blank" href={s?.url}>
            <NextImage
              objectFit="contain"
              alt="ss"
              src={s?.icon}
              width={24}
              height={24}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactUsSocial;
